import { Component, OnInit, Input, ViewEncapsulation } from "@angular/core";
import { Discussion } from "../../../../models";

@Component({
  selector: "invite-to-discussion-modal",
  templateUrl: "./invite-to-discussion-modal.component.html",
  styleUrls: [
    "./invite-to-discussion-modal.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class InviteToDiscussionModal implements OnInit {
  @Input() discussion: Discussion;
  @Input() dialogClass: string;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  public visible = false;
  public visibleAnimate = false;

  constructor() {}

  ngOnInit() {}

  public show(): void {
    this.visible = true;
    setTimeout(() => (this.visibleAnimate = true), 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => (this.visible = false), 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains("modal")) {
      this.hide();
    }
  }
}
